import { useState } from "react";
import { ticketSubmissionViewTypes } from "@twiliointernal/services-common/containers/TicketSubmissionView";

import { useSurveyContext } from "@twiliointernal/e2-commons-csat-survey";

import CallbackRequestView from "./CallbackRequestView";
import { useCallbackRequest } from "../../hooks";
import { copy, constants, types } from "./definitions";

/**
 * IMPORTANT NOTES
 *  - This component is explicity built to be used for SendGrid ingress
 *  - TODO: Clean up to make the component re-usable for any ingress and remove dependency from window object
 */
const CallbackRequest = ({ onClose }: types.CallbackRequestProps) => {
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);

  const {
    state: { ingress, token = "", user, chatId },
  } = useSurveyContext();

  const { mutateAsync: createCallbackRequestMutation } = useCallbackRequest({
    ingress,
    token,
  });

  const handleOnSubmit = async (phone: string) => {
    try {
      setLoading(true);
      const formattedPhone = phone.replace(/ /g, "-");

      // Used for dev purpose
      const devSendGridUser = constants.testUserToSendGridValuesMap[
        (window as any)?.HelpCenter?.user?.email || ""
      ] || {
        userId: user?.sendGridUserId,
        username: user?.firstName || "",
        supportPackage: {
          // This supportPackage should be received from props and not from window object
          emailSupportPackage: window.EI_Plan,
          marketingSupportPackage: window.MC_Plan,
        },
      };
      const formattedSubject = `Callback Request for ${
        window?.Username || devSendGridUser.username
      }`;
      const formattedComment = `Hello!\n\n${user?.firstName} has requested a callback:\n\nName: ${user?.firstName}\n\nCallback #: ${formattedPhone}\n\n`;

      const ticketData = {
        phoneNumber: formattedPhone,
        name: (window as any)?.HelpCenter?.user?.email || "",
        priorityLevel: "p3_general_issue",
        type: " supportCallback",
        subject: formattedSubject,
        comment: formattedComment,
        tags: [
          ticketSubmissionViewTypes.Tags.creationSourceRequestCallback,
          `${ticketSubmissionViewTypes.Tags.creationSourceRequestCallback}_chat_id_${chatId}`,
        ],
      };

      const inferredTicketData = {
        userId: user?.sendGridUserId || "",
        userName: user?.firstName || "",
        email: (window as any)?.HelpCenter?.user?.email || "",
        emailSupportPackage:
          window?.EI_Plan ||
          devSendGridUser.supportPackage?.emailSupportPackage,
        marketingSupportPackage:
          window?.MC_Plan ||
          devSendGridUser.supportPackage?.marketingSupportPackage,
      };

      const data = {
        ...ticketData,
        ...inferredTicketData,
      };

      const response = await createCallbackRequestMutation({
        data,
        options: { ticketType: "supportCallback" },
      });

      console.log("response success", response);
      // Send phone to backend and show the success notification

      if (!response.success) {
        throw new Error(copy.notificationUnreachable);
      }
      setPhoneNumber(formattedPhone);
    } catch (err: any) {
      let msg = copy.notificationRequestError;
      if (err.message === copy.notificationUnreachable) {
        msg = copy.notificationUnreachable;
      }
      // TODO Use logger here!
      console.error(err.message, msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <CallbackRequestView
      loading={loading}
      phoneNumber={phoneNumber}
      onSubmit={handleOnSubmit}
      onClose={onClose}
    />
  );
};

export default CallbackRequest;
